import { hashQueryKey } from '@tanstack/react-query';

export function ensureQueryKeyArray(value: any) {
  return Array.isArray(value) ? value : [value];
}

export function partialDeepEqual(a: any, b: any): any {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(key => !partialDeepEqual(a[key], b[key]));
  }

  return false;
}

export function partialMatchKey(a: any, b: any) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}

export function matchStatus(status: any, { state }: any) {
  return status === state.status;
}

function willBeRefreshed(
  refreshKey: string,
  mutationKey: any[] | string,
  queryKey: any[] | string
) {
  switch (refreshKey) {
    case 'all':
      return true;
    case 'same':
      return mutationKey.includes(
        Array.isArray(queryKey) ? queryKey[0] : queryKey
      );

    case 'notSame':
      return !mutationKey.includes(
        Array.isArray(queryKey) ? queryKey[0] : queryKey
      );

    default:
      return false;
  }
}
//https://github.com/tannerlinsley/@tanstack/react-query/blob/master/src/core/utils.ts
export function matchQuery(filters: any, query: any) {
  const { exact, queryKey, status, predicate, refreshKey, mutationKey } =
    filters;

  if (queryKey) {
    if (exact) {
      if (query.queryHash !== hashQueryKey(queryKey)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  } else if (mutationKey) {
    return willBeRefreshed(refreshKey, mutationKey, query.queryKey);
  }

  if (status && !matchStatus(status, query)) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}

export function matchMutation(filters: any, mutation: any) {
  const { exact, mutationKey, status } = filters;

  if (!mutation.options.mutationKey) {
    return false;
  }

  if (exact) {
    if (
      hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)
    ) {
      return false;
    }
  } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
    return false;
  }

  if (status && !matchStatus(status, mutation)) {
    return false;
  }

  return true;
}
